<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/68/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/68/title-1.png" alt="" />
                    <div class="content">
                        凡在四川天府新区成都直管区（以下简称“直管区”）范围内符合申报条件的创业就业人才，符合直管区产业发展需要的团队和项目，为直管区作出实际贡献，不受国籍限制均可按程序申报。直管区范围内的人才、团队和项目，是指在直管区注册且在直管区纳税的企业引进培育的人才、团队和项目，落地直管区的校院地协同创新平台引进培育的人才、团队和项目，社区治理和社事局下属及其管理指导的学校、医院引进培育的人才。
                    </div>
                </div>
                <div class="zccl">
                    <img class="top" src="./../assets/imgs/68/title-2.png" alt="" />
                    <div class="content">
                        <div class="title" style="
                                    font-weight: bold;
                                    font-size: 0.34rem;
                                    margin-top: 0.13rem;
                                    text-align: left;
                                ">
                            <span class="hollow-cricle"></span>（一）人才认定
                        </div>
                        <div class="des">
                            <div>
                                1.截至申报之日，申报人应在直管区全职创业或就业满9个月，并连续缴纳8个月以上社保并处于正常缴纳状态，且与用人单位签订连续不少于3年的劳动合同。
                            </div>
                            <div style="margin-top: 0.1rem">
                                2.实际工作时间3个月以上9个月以下且符合特优及以上层次人才标准的，可申请认定对应层次的“柔性人才”。
                            </div>
                            <div style="margin-top: 0.1rem">
                                3.申报高级人才年龄原则上在55岁以下；特优人才年龄原则上在50岁以下；优秀人才年龄原则上在45岁以下。
                            </div>
                            <div style="margin-top: 0.1rem">
                                4.已入选“天府英才计划”的人才，可申报高于原认定层次的人才。申报人在成都市其他区（市）县正在享受类似人才奖励补助的，不予申报。
                            </div>
                            <div style="margin-top: 0.1rem">
                                5.申报人所在用人单位是人才认定的申报主体，在新区注册成立满9个月，有规范的现代企业管理制度，有健全的财务管理制度和会计核算制度，无不良信用记录，能够为直管区做出实际贡献。用人单位作为“天府英才计划”的申报主体，上年度考核不合格的，本年度本单位申报人数总额不得超过上年度的50%；连续两个年度考核不合格的，三年内不得申报。
                            </div>
                        </div>
                        <div class="title" style="
                                    font-weight: bold;
                                    font-size: 0.34rem;
                                    margin-top: 0.13rem;
                                    text-align: left;
                                ">
                            <span class="hollow-cricle"></span>（二）团队和项目申报
                        </div>
                        <div class="des">
                            <div class="part">
                                <div class="title">
                                    1.顶级团队重大产业化项目的综合性资助
                                </div>
                                <div class="sub-title">（1）顶尖团队项目</div>
                                <div class="contents">
                                    团队带头人应为经认定的“天府英才计划”顶尖人才，并全职在直管区工作。团队核心成员中除带头人以外，另需至少3人达到领军人才入选条件或水平，并全职在直管区工作。团队以顶尖人才为引领，拥有国际一流的创新成果、明确的主攻方向和研发转化目标，符合直管区产业发展方向，在直管区开展重大产业化项目。团队研发产品具有自主知识产权和国际领先、国内一流的核心技术，能够引领带动相关产业发展。团队所在企业注册资本不少于500万元，且实缴资本不低于注册资本的50%。
                                </div>
                                <div class="sub-title">（2）高级团队项目</div>
                                <div class="contents">
                                    团队带头人应为经认定的“天府英才计划”高级及以上层次人才，并全职在直管区工作。团队核心成员中除带头人以外，另需要至少5人达到特优及以上层次人才入选条件或水平，并全职在直管区工作。团队开展的产业化项目，带头人股权不低于30%。团队研发产品具有自主知识产权和国内领先的核心技术，并已进入中试或产业化阶段，能在较短时间内取得突破性进展。团队所在企业注册资本不少于500万元，且实缴资本不低于注册资本50%。
                                </div>
                                <div class="line"></div>
                                <div class="title">
                                    2.人才创办企业的发展性资助
                                </div>
                                <div class="sub-title">（1）创业项目</div>
                                <div class="contents">
                                    申报人应为经认定的“天府英才计划”特优及以上层次人才，创办企业注册时间不少于9个月，注册地应在新区。申报人应作为主要创办人，股权不低于30％。企业拥有自主知识产权和发明专利，其核心产品处于国内领先水平，具有较大的市场潜力。企业注册资本不低于100万元，且实缴资本不低于注册资本50%。
                                </div>
                                <div class="sub-title">（2）军民融合专项</div>
                                <div class="contents">
                                    申报人应为经认定的“天府英才计划”特优及以上层次人才，创办企业注册时间不少于9个月，注册地应在新区。申报人应具有3年以上军工单位、企业从事高级研发或管理工作经历，作为主要创办人，股权不低于30%。企业应专注于军民融合产业，注册资本不低于100万元，且实缴资本不低于注册资本50%。
                                </div>
                                <div class="sub-title">（3）金融财税专项</div>
                                <div class="contents">
                                    申报人应为经认定的“天府英才计划”特优及以上层次人才，创办企业注册时间不少于9个月，注册地应在新区。申报人应具有3年以上金融行业知名机构相关工作经历，作为主要创办人，股权不低于30%。企业应专注于风险投资、资产管理、会计审计等领域，注册资本不低于100万元，且实缴资本不低于注册资本50%。
                                </div>
                                <div class="sub-title">（4）人文社科专项</div>
                                <div class="contents">
                                    申报人应为经认定的“天府英才计划”特优及以上层次人才，创办企业注册时间不少于9个月，注册地应在新区。申报人应具有文创、艺术等行业工作经历，作为主要创办人，股权不低于30％。企业应专注于文化艺术、会展博览等领域，注册资本不低于100万元，且实缴资本不低于注册资本50%。
                                </div>
                            </div>
                        </div>
                        <div class="des">
                            申报人正在享受“天府新区直管区人才创办科技型企业启动资金”资助的，不得同时申报人才创办企业的发展性资助。申报人在成都市其他区（市）县已申报类似人才创业发展性资助且正在享受相应资金资助的，不得申报。
                        </div>
                    </div>
                </div>
                <div class="zccl">
                    <img class="top" src="./../assets/imgs/68/title-3.png" alt="" />
                    <div class="content">
                        <div class="title" style="
                                    font-weight: bold;
                                    font-size: 0.34rem;
                                    margin-top: 0.13rem;
                                    text-align: left;
                                ">
                            <span class="hollow-cricle"></span>（一）人才奖励
                        </div>
                        <div class="des">
                            <div>
                                1.顶尖人才可享受500万元补贴，以及落户、人才安居、“天府新区英才卡”等各项配套政策中所对应人才层次的服务保障。
                            </div>
                            <div style="margin-top: 0.1rem">
                                2.领军人才A类可享受300万元补贴、B类享受200万元补贴、C类享受100万元补贴，以及落户、人才安居、“天府新区英才卡”等各项配套政策中所对应人才层次的服务保障。
                            </div>
                            <div style="margin-top: 0.1rem">
                                3.高级人才A类可享受100万元补贴、B类享受80万元补贴、C类享受50万元补贴，以及落户、人才安居、“天府新区英才卡”等各项配套政策中所对应人才层次的服务保障。
                            </div>
                            <div style="margin-top: 0.1rem">
                                4.特优人才A类享受50万元补贴、B类享受30万元补贴、C类享受20万元补贴，以及落户、人才安居等各项配套政策中所对应人才层次的服务保障。
                            </div>
                            <div style="margin-top: 0.1rem">
                                5.优秀人才享受10万元补贴，享受落户、人才安居等各项配套政策中所对应人才层次的服务保障。
                            </div>
                        </div>
                        <div class="title" style="
                                    font-weight: bold;
                                    font-size: 0.34rem;
                                    margin-top: 0.13rem;
                                    text-align: left;
                                ">
                            <span class="hollow-cricle"></span>（二）项目（团队）资助
                        </div>
                        <div class="des">
                            <div>
                                1.顶尖团队项目。经认定的顶尖人才为带头人的团队开展的重大产业化项目，经评审认定，以科研经费、基金投资、贷款贴息、政府奖励等形式，按照A、B、C、D四个档次，分别给予8000万元、5000万元、3000万元、1000万元的支持额度，特别优秀的可给予1亿元的支持额度，相关支持额度5年内按约定比例分批划拨到团队所在企业。
                            </div>
                            <div style="margin-top: 0.1rem">
                                2.高级团队项目。经认定的高级及以上层次人才为带头人的团队开展的产业化项目，带头人股权一般不低于30%，团队核心成员中应有相当数量的经认定的特优及以上层次人才（一般不少于5人）。根据评审结果，按A、B、C三个档次，分别给予500万元、300万元、200万元资助，按照2∶3∶5的比例分3年拨付。
                            </div>
                            <div style="margin-top: 0.1rem">
                                3.创业项目：经认定的特优及以上层次人才创办企业（股权一般不低于30%），为直管区做出实际贡献。每年择优确定资助对象，并按A、B、C三个档次，分别给予300万元、200万元、100万元资助，按照2∶3∶5的比例分3年拨付。
                            </div>
                            <div style="margin-top: 0.1rem">
                                4.军民融合专项：经认定的特优及以上层次人才创办企业（股权一般不低于30%），为直管区军民融合产业做出实际贡献。每年择优确定资助对象，并按A、B、C三个档次，分别给予300万元、200万元、100万元资助，按照2∶3∶5的比例分3年拨付。
                            </div>
                            <div style="margin-top: 0.1rem">
                                5.金融财税专项：经认定的特优及以上层次人才创办企业（股权一般不低于30%），为直管区风险投资、资产管理、会计审计等领域做出实际贡献。每年择优确定资助对象，并按A、B、C三个档次，分别给予200万元、100万元、50万元资助，按照2∶3∶5的比例分3年拨付。
                            </div>
                            <div style="margin-top: 0.1rem">
                                6.人文社科专项：鼓励特优及以上层次人才创办企业（创办人股权一般不低于30%），为直管区文创、艺术、法律等领域做出实际贡献。每年择优确定资助对象，并按A、B、C三个档次，分别给予30万元、20万元、10万元资助，按照2∶3∶5的比例分3年拨付。
                            </div>
                        </div>
                        <div class="title" style="
                                    font-weight: bold;
                                    font-size: 0.34rem;
                                    margin-top: 0.13rem;
                                    text-align: left;
                                ">
                            <span class="hollow-cricle"></span>（三）特殊奖项
                        </div>
                        <div class="des">
                            <div>
                                1.建设天府新区杰出贡献奖：对直管区经济社会发展作出杰出贡献且获得天府新区成都党工委管委会认可的专家人才，可申请该奖项。根据评定结果，一次性给予30万元的奖励。
                            </div>
                            <div style="margin-top: 0.1rem">
                                2.“天府英才计划”伯乐奖：为直管区人才引进工作做出突出贡献且获得天府新区成都党工委管委会认可的个人，可申请该奖项。根据评定结果，按照A、B两个档次，一次性给予20万元、10万元的奖励。
                            </div>
                            <div style="margin-top: 0.1rem">
                                3.“天府英才计划”优秀服务机构奖：在新区依法登记、具有独立法人资格的人才服务类机构（包括社会团体、人力资源服务企业），在招才引智、人才交流培训、人才项目对接、人力资源协同等方面作出突出贡献，可申请该奖项。根据评定结果，按A、B两个档次，一次性给予50万元、30万元奖励。已申请或正在享受人才项目资助扶持资金、直管区人才创办科技型企业的启动资金资助的机构不得申报此奖项。
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/68/title-4.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="item" style="margin-top: 0">
                                <div class="line"></div>
                                <div class="dot">1</div>
                                <div class="label">人才办发布申报指南</div>
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">2</div>
                                <div class="label">网上申报</div>
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">3</div>
                                <div class="label">部门审核</div>
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">4</div>
                                <div class="label">第三方评审</div>
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">5</div>
                                <div class="label">
                                    公安、税务、环保、市场监管等部门意见
                                </div>
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">6</div>
                                <div class="label">会议审定</div>
                            </div>
                            <div class="item">
                                <div class="dot">7</div>
                                <div class="label">公示、入库及发证</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/68/title-5.png" alt="" />
                    <div class="content" style="font-weight: bold">
                        具体申报时间和实施细则，以当年申报指南为准。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/67/title-6.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-68773465">028-68773465</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            四川天府新区人才办
                        </div>
                    </div>
                </div>
                <!-- <div class="codes">
                        <img class="code" src="../assets/imgs/67/code.png" />
                        <img class="text" src="../assets/imgs/67/text.png" />
                    </div> -->
            </div>
        </section>
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.64rem;
    }

    .technological-process {
        transform: translateY(-2.2rem);

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.22rem;
                    position: relative;

                    .part {

                        // border-bottom: 0.01rem solid #3d5aa3;
                        .title {
                            font-size: 0.28rem;
                            font-weight: bold;
                            color: #0839b7;
                        }

                        .sub-title {
                            margin-top: 0.17rem;
                            font-size: 0.26rem;
                            font-weight: bold;
                        }

                        .contents {
                            margin-top: 0.2rem;
                            margin-bottom: 0.3rem;
                        }

                        .line {
                            width: 100%;
                            height: 0.01rem;
                            background-color: #3d5aa3;
                            opacity: 0.5;
                            margin-bottom: 0.2rem;
                        }
                    }
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.22rem;
                    position: relative;

                    .item {
                        margin-top: 0.35rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;

                        // display: flex;
                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 135%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.1rem;
                            top: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }

                        .label {
                            font-size: 0.26rem;
                            font-weight: bold;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                width: 4.3rem;
            }
        }
    }
}
</style>
